import './bootstrap';
import '../css/app.css';

import { createApp } from 'vue';
import ImageConverter from './Components/ImageConverter.vue';

const app = createApp({
    components: {
        ImageConverter
    },
});
app.mount('#app');
